import { BrowserRouter, Navigate, Route, Routes, useSearchParams } from 'react-router-dom';
import { AuthProvider, RequireAuth } from './lib/auth';
import Login from './components/Login';
import SignUp from './components/SignUp';
import Dashboard from './components/Dashboard';
import CardEdit from './components/CardEdit';
import NfcPrintPage from './components/nfc/NfcPrintPage';
import PublicCard from './components/PublicCard';
import PublicInvoice from './components/PublicInvoice';
import InviteAccept from './components/InviteAccept';
import PlatformConsole from './components/PlatformConsole';
import AccountPassword from './components/AccountPassword';
import Account from './components/Account';
import Leads from './components/Leads';
import CompanyAdmin from './components/company/CompanyAdmin';
import SalesPage from './components/sales/SalesPage';
import SalesSignup from './components/sales/SalesSignup';
import { OLD_PREVIEW_BASE, SIGNUP_BASE } from './components/sales/shared';
import { useAuth } from './lib/auth';
import Loading from './components/Loading';
import UpdateBanner from './components/UpdateBanner';

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/c/:slug" element={<PublicCard />} />
          <Route path="/i/:token" element={<PublicInvoice />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<SignUp />} />
          <Route path="/invite/:token" element={<InviteAccept />} />
          <Route path="/account" element={<RequireAuth><Account /></RequireAuth>} />
          <Route path="/account/password" element={<RequireAuth><AccountPassword /></RequireAuth>} />
          <Route path="/cards/new/:orgId" element={<RequireAuth><CardEdit /></RequireAuth>} />
          <Route path="/cards/:cardId/edit" element={<RequireAuth><CardEdit /></RequireAuth>} />
          <Route path="/cards/:cardId/print" element={<RequireAuth><NfcPrintPage /></RequireAuth>} />
          <Route path="/leads" element={<RequireAuth><Leads /></RequireAuth>} />
          <Route path="/company/:orgId" element={<RequireAuth><CompanyAdmin /></RequireAuth>} />
          <Route path="/admin" element={<RequireAuth platformAdmin><PlatformConsole /></RequireAuth>} />
          {/* Unlisted preview of the new sales page (noindex). Not linked from anywhere. */}
          <Route path={SIGNUP_BASE} element={<SalesSignup />} />
          <Route path={OLD_PREVIEW_BASE} element={<Navigate to="/" replace />} />
          <Route path={`${OLD_PREVIEW_BASE}/signup`} element={<OldSignupRedirect />} />
          <Route path="/" element={<Home />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
      <UpdateBanner />
    </BrowserRouter>
  );
}

/** Old share links were /?card=<id>; they no longer resolve, so send people home. */
/** Signed-out visitors see the sales page; signed-in people get their dashboard. */
function Home() {
  const [params] = useSearchParams();
  const { session } = useAuth();
  if (params.get('card')) return <Navigate to="/login" replace />;
  if (session === undefined) return <Loading />;
  if (!session) return <SalesPage />;
  return <RequireAuth><Dashboard /></RequireAuth>;
}

/** The signup used to live under the secret preview address; keep its links (incl. email confirmations) working. */
function OldSignupRedirect() {
  const [params] = useSearchParams();
  const q = params.toString();
  return <Navigate to={`${SIGNUP_BASE}${q ? `?${q}` : ''}`} replace />;
}
